(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var bar = document.querySelector('[data-sv-topbar]');
    if (!bar) return;
    var track = bar.querySelector('[data-sv-topbar-track]');
    var slides = track ? track.children.length : 0;
    if (slides > 1) {
      var i = 0;
      var timer = setInterval(step, 6000);
      function step() { i = (i + 1) % slides; track.style.transform = 'translateY(' + (-i * 34) + 'px)'; }
      bar.addEventListener('mouseenter', function () { clearInterval(timer); });
      bar.addEventListener('mouseleave', function () { timer = setInterval(step, 6000); });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    var drawer = document.getElementById('sv-drawer');
    if (!drawer) return;
    function mountMenu() {
      var tpl = drawer.querySelector('template[data-sv-drawer-menu]');
      if (!tpl) return;
      tpl.replaceWith(tpl.content.cloneNode(true));
    }
    var openers = document.querySelectorAll('[data-sv-drawer-open]');
    function announce(state) {
      openers.forEach(function (b) { b.setAttribute('aria-expanded', state); });
    }
    function open() { mountMenu(); drawer.hidden = false; document.body.style.overflow = 'hidden'; announce('true'); }
    function close() { drawer.hidden = true; document.body.style.overflow = ''; announce('false'); }
    openers.forEach(function (b) { b.addEventListener('click', open); });
    drawer.querySelectorAll('[data-sv-drawer-close]').forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !drawer.hidden) close(); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sv-hero-video"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* Vídeo de fundo, sempre DEPOIS do LCP (idle). Celular recebe o corte 4:5 leve
       (data-mobile-src); desktop, o widescreen das <source>. */
    document.querySelectorAll('[data-sv-video]').forEach(function (v) {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      var net = navigator.connection || {};
      if (net.saveData) return;
      if (net.effectiveType === '2g' || net.effectiveType === 'slow-2g') return;

      var wide = window.matchMedia('(min-width: 750px)').matches;
      var mobileSrc = v.dataset.mobileSrc;

      var load = function () {
        if (!wide && mobileSrc) {
          v.querySelectorAll('source').forEach(function (s) { s.remove(); });
          v.src = mobileSrc;
        } else {
          v.querySelectorAll('source[data-src]').forEach(function (s) {
            s.src = s.dataset.src;
            s.removeAttribute('data-src');
          });
        }
        v.load();
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
      };
      if ('requestIdleCallback' in window) requestIdleCallback(load, { timeout: 2500 });
      else setTimeout(load, 1200);
    });

    document.querySelectorAll('[data-sv-hero]').forEach(function (hero) {
      var slides = hero.querySelectorAll('[data-sv-slide]');
      var dots = hero.querySelectorAll('[data-sv-dot]');
      if (slides.length < 2) return;
      var i = 0;
      var timer;
      function go(n) {
        slides[i].classList.remove('is-active');
        if (dots[i]) { dots[i].classList.remove('is-active'); dots[i].setAttribute('aria-selected', 'false'); }
        i = (n + slides.length) % slides.length;
        slides[i].classList.add('is-active');
        if (dots[i]) { dots[i].classList.add('is-active'); dots[i].setAttribute('aria-selected', 'true'); }
      }
      function start() { timer = setInterval(function () { go(i + 1); }, 6000); }
      function stop() { clearInterval(timer); }
      dots.forEach(function (d) {
        d.addEventListener('click', function () { stop(); go(parseInt(d.dataset.svDot, 10)); start(); });
      });
      if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) start();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sv-wishlist"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var page = document.querySelector('[data-sv-wishpage]');
    if (!page) return;
    var KEY = 'sv_wishlist';
    var grid = document.querySelector('[data-sv-wishgrid]');
    var skel = document.querySelector('[data-sv-wishskeleton]');
    var empty = document.querySelector('[data-sv-wishempty]');
    var error = document.querySelector('[data-sv-wisherror]');
    var sub = document.querySelector('[data-sv-wishsub]');
    var clearBtn = document.querySelector('[data-sv-wishclear]');
    var recs = document.querySelector('[data-sv-wishrecs]');
    var recTitle = document.querySelector('[data-sv-wishrectitle]');
    var recItems = recs ? [].slice.call(recs.querySelectorAll('[data-handle]')) : [];

    function read() {
      try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; }
    }

    // handle -> <li> (ordem final = ordem do localStorage, não de chegada)
    var cards = {};
    [].slice.call(grid.children).forEach(function (li) {
      cards[li.dataset.handle] = li;
      var btn = li.querySelector('[data-sv-wish]');
      var title = li.querySelector('.sv-pcard__title');
      if (btn && title) btn.setAttribute('aria-label', 'Remover ' + title.textContent.trim() + ' da lista de desejos');
    });

    function render() {
      var saved = read();
      var found = 0;
      skel.hidden = true;
      Object.keys(cards).forEach(function (h) { cards[h].hidden = true; });
      saved.forEach(function (h) {
        var li = cards[h];
        if (!li) return;
        li.hidden = false;
        grid.appendChild(li);
        found++;
      });
      grid.hidden = found === 0;
      empty.hidden = saved.length > 0;
      error.hidden = !(saved.length > 0 && found === 0);
      clearBtn.hidden = saved.length === 0;
      sub.textContent = saved.length
        ? saved.length + (saved.length === 1 ? ' produto salvo' : ' produtos salvos') + '. Toque no coração para remover.'
        : 'Guarde aqui as bordas e pisos que você ama para comprar depois.';

      if (!recs) return;
      recTitle.textContent = saved.length > 0 ? 'Você também pode gostar' : 'Comece por aqui';
      var shown = 0;
      recItems.forEach(function (el) {
        var keep = saved.indexOf(el.dataset.handle) === -1 && shown < 8;
        el.hidden = !keep;
        if (keep) shown++;
      });
      recs.hidden = shown === 0;
    }

    clearBtn.addEventListener('click', function () {
      if (window.SilvanoWishlist) window.SilvanoWishlist.clear();
    });

    window.addEventListener('sv:wishlist', render);
    window.addEventListener('storage', function (e) { if (!e.key || e.key === KEY) render(); });
    render();
  })();

  } catch(e) { console.error(e); }
})();
})();
